import React, { useEffect, useState, useContext } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { DialogBox } from '../../../components/singleComponents/dialogs/DialogBox';
import { Header } from '../../../components/singleComponents/headers';
import { TableCategories } from '../../../components/singleComponents/tables/TableCategories';
import ToasterBox from '../../../components/singleComponents/toaster/ToasterBox';

import api, { authHeader } from '../../../../services/API/apiConfig';
import {
  BtnNewCategoryStyled,
  ModalNewCategoryStyled,
  RootStyled,
  TitlePageStyled,
} from './Categories.styles';
import { TourContext } from '../../../../context/tour';
import { MOCK_CATEGORIES } from '../../../../services/driverJS/mocks';

export function Categories() {
  const { isTourOn } = useContext(TourContext);

  const [categories, setCategories] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [categoryName, setCategoryName] = useState('');
  const [categoryId, setCategoryId] = useState(null);
  const [openDialogRemoveCategory, setOpenDialogRemoveCategory] =
    useState(false);
  const [toasterMessage, setToasterMessage] = useState('');
  const [loadingButton, setLoadingButton] = useState(false);

  const getCategories = async () => {
    await api
      .get('/categories', {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setCategories(data);
      });
  };

  const openRemovalDialog = (id) => {
    setCategoryId(id);
    setOpenDialogRemoveCategory(true);
  };

  const closeRemovalDialog = () => {
    setCategoryId(null);
    setOpenDialogRemoveCategory(false);
  };

  const editCategoryName = (id) => {
    setOpenModal(!openModal);
    setCategoryId(id);
    api
      .get(`/categories/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setCategoryName(data.name);
      });
  };

  const addNewCategory = async () => {
    const data = {
      category: {
        name: categoryName,
      },
    };
    setLoadingButton(true);
    if (categoryId) {
      await api
        .patch(`/categories/${categoryId}`, data, {
          headers: authHeader(),
        })
        .then((res) => {
          if (res.data.status === 0) {
            setTimeout(() => {
              getCategories();
              setCategoryId(null);
              setCategoryName('');
              setOpenModal(!openModal);
            }, 2000);
          } else if (res.data.status === 2) {
            setToasterMessage('Já existe uma categoria com esse nome.');
          }
        })
        .finally(() => {
          setLoadingButton(false);
        });
    } else {
      await api
        .post('/categories', data, {
          headers: authHeader(),
        })
        .then((res) => {
          if (res.data.status === 0) {
            setTimeout(() => {
              getCategories();
              setLoadingButton(false);
              setOpenModal(!openModal);
              setCategoryName('');
            }, 1500);
          } else if (res.data.status === 2) {
            setToasterMessage('Já existe uma categoria com esse nome.');
          }
        })
        .finally(() => {
          setLoadingButton(false);
          setTimeout(() => {
            setToasterMessage('');
          }, 2500);
        });
    }
  };

  const deleteCategory = async (id) => {
    api
      .delete(`/categories/${id}`, {
        headers: authHeader(),
      })
      .then(() => {
        getCategories();
        closeRemovalDialog();
        setToasterMessage('Categoria deletada com sucesso.');
      })
      .catch(({ response }) => {
        closeRemovalDialog();
        setToasterMessage(response.data.message);
      })
      .finally(() => {
        setTimeout(() => {
          setToasterMessage('');
        }, 2500);
      });
  };

  const closeModal = () => {
    setCategoryId(null);
    setCategoryName('');
    setOpenModal(!openModal);
  };

  useEffect(() => {
    api
      .get('/categories', {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setCategories(data);
      });
  }, []);

  return (
    <>
      <Header page="Categorias" />
      <RootStyled>
        {toasterMessage && <ToasterBox message={toasterMessage} />}
        <TitlePageStyled>
          <BtnNewCategoryStyled
            id="new-category-btn"
            onClick={() => setOpenModal(!openModal)}
          >
            Nova Categoria
          </BtnNewCategoryStyled>
        </TitlePageStyled>
        <TableCategories
          categories={isTourOn ? MOCK_CATEGORIES : categories}
          editCategoryName={editCategoryName}
          openRemovalDialog={openRemovalDialog}
        />
      </RootStyled>
      <ModalNewCategoryStyled open={openModal} onClose={closeModal}>
        <Box className="box">
          <Typography variant="h3">
            {categoryId ? 'Editar categoria' : 'Nova categoria'}
          </Typography>
          <TextField
            label="Nome da categoria"
            color="secondary"
            variant="outlined"
            slotProps={{
              inputLabel: { shrink: true },
            }}
            focused
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
          />
          <div className="containerButtons">
            <Typography variant="subtitle2" onClick={closeModal}>
              Cancelar
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              className="saveButton"
              onClick={addNewCategory}
            >
              {loadingButton ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <p>Salvar</p>
              )}
            </Button>
          </div>
        </Box>
      </ModalNewCategoryStyled>
      <DialogBox
        title="Remover categoria"
        content="Deseja realmente remover essa categoria? Essa ação não poderá ser desfeita."
        openDialog={openDialogRemoveCategory}
        closeDialog={closeRemovalDialog}
        mainAction={() => deleteCategory(categoryId)}
      />
    </>
  );
}
